<template>
    <div class="catalog-slider">
        <div class="catalog-slider__wrap swiper-wrapper">
            <div class="catalog-slider__slide swiper-slide"
                 :key="index+'avatar'"
                 v-for="(item, index) in avatarList"
                 @click="selectAvatar(index, item)"

            >
                <div class="catalog-slider__slide-img-wrap"
                     :class="{'catalog-slider__slide-img-wrap--selected': index===selectedAvatar}">
                    <div class="catalog-slider__slide-img-highlight">
                        <img class="catalog-slider__slide-img"
                             :src="item.image">
                    </div>
                </div>
                <div class="catalog-slider__slide-title">{{item.title}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';


    export default {
        name: "AvatarSlider",
        props: {
            avatarList: {
                type: Array,
                default: function () {
                    return []
                }
            },
            preSelectedAvatar: {
                type: Number,
                default: 0
            },
            teamIndex: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                selectedAvatar: this.preSelectedAvatar,

            }
        },
        computed: {
            ...mapGetters([
                'playersPreset',
            ])
        },
        methods: {
            selectAvatar: function (index, item) {

                this.selectedAvatar = index;
                this.updPlayerImg([this.$_.findIndex(this.playersPreset, item), this.teamIndex])
                this.updPlayerTitle([this.avatarList[index].title, this.teamIndex])
                this.$emit('selectAvatar')
            },
            ...mapActions([
                'updPlayerImg',
                'updPlayerTitle',
            ])
        },

    }
</script>

<style lang="scss">
    .catalog-slider {

        &__wrap {
            display: flex;
            overflow-y: hidden;
        }
        &__slide {
            display: inline-flex;
            flex-direction: column;
            flex: 0 0 70px;
            margin-right: 12px;
            max-width: 70px;
            text-align: center;
            padding: 16px 0 16px;

            &:first-child {
                margin-left: 16px;
            }

            &:last-child {
                margin-right: 8px;
            }

        }

        &__slide-img-wrap {
            width: 70px;
            height: 70px;
            background: #FFFFFF;
            box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);
            border: 1px solid #eee;
            border-radius: 20px;
            margin-bottom: 8px;
            transition: all .02s ease;
            overflow: hidden;

            &:active {
                /*transform: scale(.96);*/
                box-shadow: 0 4px 30px rgba(3, 210, 28, 0.08), inset 0 0 0 2px rgb(0, 187, 14);
            }

            &--selected {
                box-shadow: 0 4px 10px rgba(3, 210, 28, 0.08), inset 0 0 0 2px rgb(0, 187, 14);
            }
        }

        &__slide-img {
            max-width: 50px;
            max-height: 50px;
        }

        &__slide-img-highlight {
            cursor: pointer;
            -webkit-tap-highlight-color: rgba(3, 210, 28, 0.08);
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__slide-title {
            font-size: 12px;
            opacity: .6;
            max-width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }

    }
</style>
